/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { RootState, SystemEntity } from '../../../../ts/state';

export const getById = (state: RootState, id: string): SystemEntity =>
  state.models.systemEntities[id];

export const getSys = (state: RootState): SystemEntity[] =>
  state.systemEntities?.sysIds.map(id => getById(state, id));
